import { render, staticRenderFns } from "./RiskAssesment.vue?vue&type=template&id=03c27b2a&scoped=true&"
import script from "./RiskAssesment.vue?vue&type=script&lang=js&"
export * from "./RiskAssesment.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssesment.vue?vue&type=style&index=0&id=03c27b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c27b2a",
  null
  
)

export default component.exports